import { render, staticRenderFns } from "./ClientesConectaPantalla.vue?vue&type=template&id=da04653a&"
import script from "./ClientesConectaPantalla.vue?vue&type=script&lang=ts&"
export * from "./ClientesConectaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('da04653a', component.options)
    } else {
      api.reload('da04653a', component.options)
    }
    module.hot.accept("./ClientesConectaPantalla.vue?vue&type=template&id=da04653a&", function () {
      api.rerender('da04653a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Clientes/ClientesConectaPantalla.vue"
export default component.exports